import { render } from "./SearchSlots.vue?vue&type=template&id=3398ba44&scoped=true&ts=true"
import script from "./SearchSlots.vue?vue&type=script&lang=ts"
export * from "./SearchSlots.vue?vue&type=script&lang=ts"

import "./SearchSlots.vue?vue&type=style&index=0&id=3398ba44&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3398ba44"]])

export default __exports__